<div class="container-xxl container-p-y">
  <div class="misc-wrapper d-flex justify-content-center align-items-center">
      <img src="@/assets/images/404.png"  alt="404 'This is not the web page you are looking for'">
  </div>
    <div>
        <button >Quay về trang chủ</button>
    </div>
</div>
